export default __webpack_public_path__ + "static/media/avatar.6712e245.png";